export enum sex {
    Both = 'Both',
    Female = 'Female',
    Male = 'Male',
    Unknown = 'Unknown'
}

export enum sexEx {
    Both = 'Diverse',
    Female = 'Female',
    Unknown = 'Unknown',
    Male = 'Male'
}

export enum casualStatus {
    CasualWithHandicap = 'CasualWithHandicap',
    CasualWithoutHandicap = 'CasualWithoutHandicap',
    Normal = 'Normal'
}

export enum familyStatus {
    Head = 'Head',
    Member = 'Member',
    Single = 'Single'
}

export enum memberStatus {
    Guest = 'Guest',
    IndependentPlayer = 'IndependentPlayer',
    Member = 'Member',
    Business = 'Business'
}

export enum cardOrderStatus {
    CheckedInAssocNOk = 'CheckedInAssocNOk',
    CheckedInAssocOk = 'CheckedInAssocOk',
    CheckedReadyToBeSent = 'CheckedReadyToBeSent',
    Failed = 'Failed',
    NoOrder = 'NoOrder',
    PreOrdered = 'PreOrdered',
    Preliminary = 'Preliminary',
    Received = 'Received',
    RejectedByAssociation = 'RejectedByAssociation',
    SentToAssociation = 'SentToAssociation',
    ValidatedByAssociation = 'ValidatedByAssociation'
}

export enum customerClubType {
    Home = 'Home',
    Second = 'Second',
    Other = 'Other'
}

export enum playRights {
    Limited = 'Limited',
    Unlimited = 'Unlimited',
    WithoutRights = 'WithoutRights'
}

export enum handedness {
    Unknown = 'Unknown',
    Right = 'Right',
    Left = 'Left'
}

export enum contactUsageType {
    Private = 'Private',
    Business = 'Business'
}

export enum extraFieldType {
    String = 'String',
    Integer = 'Integer',
    Decimal = 'Decimal',
    Boolean = 'Boolean',
    Enum = 'Enum',
    Date = 'Date',
    Time = 'Time',
    DateTime = 'DateTime'
}

export enum exportConfigObjectType {
    Unknown = 'Unknown',
    Customer = 'Customer'
}

export enum customerContactFields {
    ContactTypeId = 'ContactTypeId',
    Main = 'Main',
    AddressId = 'AddressId',
    LetterAddressId = 'LetterAddressId',
    CountryId = 'CountryId',
    RegionId = 'RegionId',
    Active = 'Active',
    OrderNo = 'OrderNo',
    StartDate = 'StartDate',
    EndDate = 'EndDate',
    Notes = 'Notes',
    UseCompanyName = 'UseCompanyName',
    CompanyName = 'CompanyName',
    VatNumber = 'VatNumber',
    PostalAddress = 'PostalAddress'
}

export enum customerEmailFields {
    UsageType = 'UsageType',
    Main = 'Main',
    Email = 'Email',
    Active = 'Active',
    OrderNo = 'OrderNo',
    StartDate = 'StartDate',
    EndDate = 'EndDate',
    Notes = 'Notes'
}

export enum dgvSheetKind {
    M = 'M',
    I = 'I',
    T = 'T',
    MF = 'MF',
    MTI = 'MTI',
    MTA = 'MTA',
    S = 'S',
    Z313 = 'Z313',
    Z314 = 'Z314',
    Z312 = 'Z312',
    Z315 = 'Z315',
    HcpActive = 'HcpActive',
    HcpInActive = 'HcpInActive',
    ITA = 'ITA',
    TTA = 'TTA',
    CW = 'CW'
}

export enum entryVersion {
    Kongu = 'Kongu',
    PreCsa = 'PreCsa',
    Csa = 'Csa',
    Cba = 'Cba',
    Actual = 'Actual'
}

export enum hdcRelevantStatus {
    HcpRelevant = 'HcpRelevant',
    NotHcpRelevant = 'NotHcpRelevant',
    Canceled = 'Canceled',
    NonDecreasing = 'NonDecreasing',
    TigerAndRabbit = 'TigerAndRabbit',
    TournamentCancelled = 'TournamentCancelled'
}

export enum hdcResultStatus {
    Normal = 'Normal',
    DisqualifiedWithResult = 'DisqualifiedWithResult',
    DisqualifiedWithoutResult = 'DisqualifiedWithoutResult',
    NoReturnIll = 'NoReturnIll',
    NoReturnDisqualified = 'NoReturnDisqualified'
}

export enum hdcSheetKind {
    Stableford = 'Stableford',
    Strokeplay = 'Strokeplay',
    AgainstPar = 'AgainstPar',
    PrivateRound = 'PrivateRound',
    //ExtraDayScore = 'ExtraDayScore',
    EdsStableford = 'EdsStableford',
    EdsStrokeplay = 'EdsStrokeplay',
    EdsAgainstPar = 'EdsAgainstPar',
    Correction = 'Correction',
    Association = 'Association',
    HandicapAdjustment = 'HandicapAdjustment',
    First = 'First',
    Conversion = 'Conversion',
    Pseudo = 'Pseudo',
    ChildrenBadge = 'ChildrenBadge',
    Reservation = 'Reservation',
    BlockHcp = 'BlockHcp',
    UnblockHcp = 'UnblockHcp',
    HcpCommitteeChange = 'HcpCommitteeChange',
    StatAnalisisCorrection = 'StatAnalisisCorrection',
    HcpBecameActive = 'HcpBecameActive',
    HcpBecameInactive = 'HcpBecameInactive',
    ClubTransition = 'ClubTransition'
}

export enum hdcSheetSource {
    Manual = 'Manual',
    Tournament = 'Tournament',
    Federation = 'Federation',
    Import = 'Import'
}

export enum membershipChangeState {
    None = 'None',
    Planned = 'Planned',
    Cancelled = 'Cancelled',
    Success = 'Success',
    Error = 'Error'
}

export enum cardParamsValidType {
    Period = 'Period',
    EndDate = 'EndDate'
}

export enum custFilterTextFields {
    Number = 'Number',
    FirstName = 'FirstName',
    LastName = 'LastName',
    EmailAny = 'EmailAny',
    EmailMain = 'EmailMain',
    PhoneAny = 'PhoneAny',
    PhoneMainForCall = 'PhoneMainForCall',
    PhoneMainForSms = 'PhoneMainForSms',
    HomeClubCode = 'HomeClubCode',
    HomeClubName = 'HomeClubName'
}

export enum textLikeType {
    ExactMatch = 'ExactMatch',
    StartWith = 'StartWith',
    Contains = 'Contains',
    EndWith = 'EndWith'
}

export enum CardTypes {
    Unknown = 'Unknown',
    Magnetic = 'Magnetic',
    Mifare = 'Mifare',
    SkiData = 'SkiData',
    GolfCard = 'GolfCard',
    ChipCard = 'ChipCard',
    BarCode = 'BarCode',
    Legic = 'Legic'
}

export enum BatchTypes {
    Assign = 'Assign',
    Delete = 'Delete'
}

export enum FullNameEnum {
    Comma = 'Comma',
    FirstName = 'FirstName',
    FirstNameInitial = 'FirstNameInitial',
    LastName = 'LastName',
    LastNameInitial = 'LastNameInitial',
    MiddleName = 'MiddleName',
    MiddleNameInitial = 'MiddleNameInitial',
    NameExtra = 'NameExtra',
    None = 'None',
    Title = 'Title'
}

export enum activityType {
    Unknown = 'Unknown',
    EmailReceived = 'EmailReceived',
    EmailSent = 'EmailSent',
    EmailDocumentSent = 'EmailDocumentSent',
    SmsSent = 'SmsSent',
    UnsentEmailPrinted = 'UnsentEmailPrinted',
    UnsentEmailDocumentPrinted = 'UnsentEmailDocumentPrinted',
    SerialLetterSent = 'SerialLetterSent',
    AccountingDocumentPrepared = 'AccountingDocumentPrepared',
    AccountingDocumentSent = 'AccountingDocumentSent',
    DmsDocumentUploaded = 'DmsDocumentUploaded',
    DmsDocumentScanned = 'DmsDocumentScanned',
    DmsDocumentFromEmail = 'DmsDocumentFromEmail',
    DmsDocumentPrinted = 'DmsDocumentPrinted',
    MemoAssigned = 'MemoAssigned',
    TaskAssigned = 'TaskAssigned',
    UpcomingNotificationSent = 'UpcomingNotificationSent',
    CardOrdered = 'CardOrdered',
    CardOrderDeleted = 'CardOrderDeleted',
    MedicalCertificate = 'MedicalCertificate',
    MedicalCertificateWithDocument = 'MedicalCertificateWithDocument'
}

/*
export enum accountConfirmed {
    JustRegistered = 'JustRegistered',
    Confirmed = 'Confirmed',
    DefaultPasswordChanged = 'DefaultPasswordChanged'
}
*/

export enum confirmationStatus {
    CreatedByCustomer = 'CreatedByCustomer',
    Confirmed = 'Confirmed',
    CreatedByStaff = 'CreatedByStaff',
    NotRegistered = 'NotRegistered'
}

export enum customerVisibility {
    DataNotShown = 'DataNotShown',
    MemberNumberSeenByAll = 'MemberNumberSeenByAll',
    MemberNumberSeenOnlyBYMembers = 'MemberNumberSeenOnlyBYMembers',
    NameSeenByAll = 'NameSeenByAll',
    NameSeenOnlyByMembers = 'NameSeenOnlyByMembers'
}

export enum cardBatchItemStatus {
    Success = 'Success',
    AlreadyAssigned = 'AlreadyAssigned',
    DataMissing = 'DataMissing'
}

export enum cwiNavigation {
    List = 'List',
    Tiles = 'Tiles'
}

export enum customerProStatus {
    Amateur = 'Amateur',
    ProWithHcp = 'ProWithHcp',
    ProWithoutHcp = 'ProWithoutHcp'
}

export enum customerLastUpdateFromAssocStatus {
    NotUpdated = 'NotUpdated',
    Updated = 'Updated',
    UpdatedOnlyEhcp = 'UpdatedOnlyEhcp',
    UpdatedWithoutEhcp = 'UpdatedWithoutEhcp'
}

export enum customerPhoneFields {
    UsageType = 'UsageType',
    PhoneTypeId = 'PhoneTypeId',
    MainForCall = 'MainForCall',
    MainForSms = 'MainForSms',
    Phone = 'Phone',
    Active = 'Active',
    OrderNo = 'OrderNo',
    StartDate = 'StartDate',
    EndDate = 'EndDate',
    Notes = 'Notes'
}

export enum customerSocialType {
    Other = 'Other',
    Facebook = 'Facebook',
    Twitter = 'Twitter',
    LinkedIn = 'LinkedIn',
    Instagram = 'Instagram'
}

export enum customerImsType {
    Other = 'Other',
    Skype = 'Skype',
    Icq = 'Icq',
    WhatsApp = 'WhatsApp'
}

export enum forceEnum {
    NoForce = 'NoForce',
    ForcePrimary = 'ForcePrimary',
    ForceSecondary = 'ForceSecondary'
}

export enum calculationType {
    Undefined = 'Undefined',
    Yearly = 'Yearly',
    Daily = 'Daily'
}

export enum kindGroupType {
    Other = 'Other',
    Customer = 'Customer',
    News = 'News',
    CustomerOther = 'CustomerOther',
    NewsOther = 'NewsOther'
}

export enum customerActionType {
    Tournament = 'Tournament',
    Reservation = 'Reservation',
    Event = 'Event'
}

export enum vaccinationStatus {
    NotVaccinated = 'NotVaccinated',
    Unknown = 'Unknown',
    Vaccinated = 'Vaccinated'
}

export enum birthdayNotifyTypeEnum {
    Default = 'Default',
    Allow = 'Allow',
    Deny = 'Deny'
}

export enum certificateTypeEnum {
    DoctorApproved = 'DoctorApproved'
}

export enum formatNameEnum {
    title_firstName_nameExtra_lastName = 'title_firstName_nameExtra_lastName',
    nameExtra_lastName_title_firstName = 'nameExtra_lastName_title_firstName',
    firstName_lastName = 'firstName_lastName',
    lastName_firstName = 'lastName_firstName'
}

export enum medCertificateStatusEnum {
    Active = 'Active',
    Inactive = 'Inactive',
    ToBeRenewed = 'ToBeRenewed',
    NotExists = 'NotExists'
}

export enum receivedFromServerEnum {
    Found = 'Found',
    None = 'None',
    Received = 'Received'
}

export enum tnFeePayMethod {
    Account,
    DirectDebit,
    Pos
}

export enum customerKind {
    Company = 'Company',
    Customer = 'Customer',
    CustomerNeedApproval = 'CustomerNeedApproval',
    Staff = 'Staff'
}
